<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Swap CETIP"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.CETIP"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('operationValue')">
          <label>Valor da Operação</label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('expirationDate')">
          <label>Data de Vencimento</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control"
            name="expirationDate"
            data-cy="expirationDate"
            [(ngModel)]="model.expirationDate"
            required
          />
        </div>
        <div class="col-4">
          <label>Comando</label>
          <input
            class="form-control"
            data-cy="command"
            type="text"
            name="command"
            [(ngModel)]="model.command"
            maxlength="10"
            value=""
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4">
          <label>Indexador Ativo</label>
          <input
            type="text"
            data-cy="activeIndex"
            class="form-control"
            name="activeIndex"
            [(ngModel)]="model.activeIndex"
            maxlength="10"
            required
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('activeIndexPercent')">
          <label>Percentual do Indexador Ativo</label>
          <input
            type="text"
            data-cy="activeIndexPercent"
            class="form-control"
            name="activeIndexPercent"
            [(ngModel)]="model.activeIndexPercent"
            required
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('activeIndexTax')">
          <label>Taxa do Indexador Ativo</label>
          <input
            type="text"
            data-cy="activeIndexTax"
            class="form-control"
            name="activeIndexTax"
            [(ngModel)]="model.activeIndexTax"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-2" [class.has-error]="hasError('activeIndexBase')">
          <label>Base Indexador Ativo</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaBaseIndexador; index as i"
            >
              <input
                class="form-check-input"
                data-cy="activeIndexBase"
                type="radio"
                id="ActiveIndexBase-{{ i }}-id"
                name="activeIndexBase"
                [(ngModel)]="model.activeIndexBase"
                [value]="item.id"
                required
              />

              <label class="form-check-label" for="ActiveIndexBase-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-3" [class.has-error]="hasError('activeInterestType')">
          <label for="termo">Tipo de Juros do Indexador Ativo</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoJuros; index as i"
            >
              <input
                class="form-check-input"
                data-cy="activeInterestType"
                type="radio"
                id="ActiveInterestType-{{ i }}-id"
                name="activeInterestType"
                [(ngModel)]="model.activeInterestType"
                [value]="item.id"
                required
              />

              <label
                class="form-check-label"
                for="ActiveInterestType-{{ i }}-id"
              >
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Indexador Passivo</label>
          <input
            type="text"
            data-cy="passiveIndex"
            class="form-control"
            name="passiveIndex"
            [(ngModel)]="model.passiveIndex"
            maxlength="10"
            required
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('passiveIndexPercent')">
          <label>Percentual Indexador do Passivo</label>
          <input
            type="text"
            data-cy="passiveIndexPercent"
            class="form-control"
            name="passiveIndexPercent"
            required
            [(ngModel)]="model.passiveIndexPercent"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('passiveIndexTax')">
          <label>Taxa do Indexador Passivo</label>
          <input
            type="text"
            data-cy="passiveIndexTax"
            class="form-control"
            name="passiveIndexTax"
            required
            [(ngModel)]="model.passiveIndexTax"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('passiveIndexBase')">
          <label>Base Indexador do Passivo</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaBaseIndexador; index as i"
            >
              <input
                class="form-check-input"
                data-cy="passiveIndexBase"
                type="radio"
                id="PassiveIndexBase-{{ i }}-id"
                name="passiveIndexBase"
                [(ngModel)]="model.passiveIndexBase"
                [value]="item.id"
                required
              />

              <label class="form-check-label" for="PassiveIndexBase-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-4" [class.has-error]="hasError('passiveInterestType')">
          <label for="termo">Tipo de Juros do Indexador Passivo</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoJuros; index as i"
            >
              <input
                class="form-check-input"
                type="radio"
                id="PassiveInterestType-{{ i }}-id"
                name="passiveInterestType"
                [(ngModel)]="model.passiveInterestType"
                [value]="item.id"
                required
              />

              <label
                class="form-check-label"
                for="PassiveInterestType-{{ i }}-id"
              >
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.SwapCetip"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  >
  </app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      data-cy="submit"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Encaminhar"
      data-cy="forward"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
